/**
 * WebSocket initialization composable
 * Ensures WebSocket connects on app load if market is open
 */

import { onMounted, onBeforeUnmount } from 'vue'
import { wsService } from '@/services/websocket'
import { MarketHours } from '@/utils/marketHours'

export function useWebSocketInit() {
  let marketCheckInterval: NodeJS.Timeout | null = null

  onMounted(() => {
    // Check market status and connect if open
    checkAndConnect()

    // Recheck periodically (every minute)
    marketCheckInterval = setInterval(checkAndConnect, 60000)

    // Handle page visibility changes
    document.addEventListener('visibilitychange', handleVisibilityChange)
  })

  onBeforeUnmount(() => {
    if (marketCheckInterval) {
      clearInterval(marketCheckInterval)
    }
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  })

  function checkAndConnect() {
    const isMarketOpen = MarketHours.isMarketOpen()
    
    if (isMarketOpen && !wsService.isConnected()) {
      console.log('🔌 Market is open - ensuring WebSocket connection')
      wsService.connect()
    }
  }

  function handleVisibilityChange() {
    if (!document.hidden) {
      // Page became visible - check connection
      checkAndConnect()
    }
  }

  return {
    checkAndConnect
  }
}
